import { AlphaTCircleIcon } from './AlphaTCircleIcon';

/**
 * author: Contributors
 * id 6A41607E-FD2D-49EB-B6A5-67472ECF381E
 * name alpha-t-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterTCircleIcon = AlphaTCircleIcon;
export default LetterTCircleIcon